import { ChannelCustomerResponse } from './../../core/models/ChannelCustomerResponse';
import { ChannelData } from 'src/app/core/models';
import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PageName } from 'src/app/core/enums/PageName';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Injectable({ providedIn: 'root' })
export class RoutingService {
  private homePageUrl: string = window.location.origin + '/' + environment.eorderChannel + '/home';

  constructor(
    private activatedRoute: ActivatedRoute,
    private navigationService: NavigationService
  ) { }

  navigate(pageName: PageName, channelData?: ChannelData) {
    switch (pageName) {
      case PageName.LoginPage: {
        this.navigationService.navigate(["login"], { relativeTo: this.activatedRoute });
        break;
      }
      case PageName.ForgotPasswordPage: {
        this.navigationService.navigate(["forgot-password"], { relativeTo: this.activatedRoute });
        break;
      }
      case PageName.SignupPage: {
        this.navigationService.navigate(["register"], { relativeTo: this.activatedRoute });
        break;
      }
      case PageName.HomePage: {
        if (channelData && channelData?.homeChannelTag && channelData?.homeChannelTag !== channelData.channelTag) {
          this.navigateHomeUrl(channelData.homeChannelTag);
        } else {
          this.navigationService.navigate(["home"], {  relativeTo: this.activatedRoute });
        }
        break;
      }
      default: {
        break;
      }
    }
  }

  navigateHomeCheck(channelResponse : ChannelCustomerResponse){
    if(channelResponse.homeChannelTag != channelResponse.channelTag){
      this.navigateHomeUrl(channelResponse.homeChannelTag);
    }
    else{
      this.navigationService.navigate(["home"], {  relativeTo: this.activatedRoute });
    }
  }

  navigateHomeUrl(specificChannel?: string) {
    // this.navigationService.navigate([""]);
    this.navigationService.navigate(["home"], {  relativeTo: this.activatedRoute });
  }

  navigateChannelUrl(channelTag: string, page: string) {
    let upperCaseChannel = channelTag.toUpperCase();
    window.location.href = window.location.origin + '/' + upperCaseChannel + '/' + page;
  }
}
